import { EntityAdapter, EntityState, createEntityAdapter } from '@ngrx/entity';
import { EntityAcreditacionEmpresa } from './entity-acreditacion-empresa.model';

export const entityAcreditacionEmpresaAdapter: EntityAdapter<EntityAcreditacionEmpresa> =
  createEntityAdapter<EntityAcreditacionEmpresa>({
    selectId: (model) => model.id,
    sortComparer: (a: EntityAcreditacionEmpresa, b: EntityAcreditacionEmpresa): number =>
      b.id.toString().localeCompare(a.id.toString())
  });

export interface EntityAcreditacionEmpresaState extends EntityState<EntityAcreditacionEmpresa> {
  isLoading?: boolean;
  hasAddedSuccess?: boolean;
  error?: Error | null | any;
}

export const initialState: EntityAcreditacionEmpresaState = entityAcreditacionEmpresaAdapter.getInitialState({
  isLoading: false,
  hasAddedSuccess: false,
  error: null
});
